import { Injectable } from '@angular/core';
import { ToastController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class ToastService {
  
  constructor(private toastController: ToastController, public translate: TranslateService) { }

  async present(message: string, duration?: number, position?: 'top' | 'bottom' | 'middle', icon?: string, cssClass?:string) {
    const toast = await this.toastController.create({
      message: this.translate.instant(message),
      duration: duration || 3000,
      position: position || 'bottom',
      cssClass: cssClass || 'popup-message-slide',
      icon: icon || undefined,
      mode: 'ios',
      animated: true,
    });
    await toast.present();
    return toast;
  }

  async dismiss(toast) {
    toast.dismiss();
  }
}
